import { connect } from "react-redux";

import {
  selectUserIsLoggedIn,
  selectUserIsLoading
} from "selector/authSelectors";

export const mapStateToProps = (state, ownProps) => {
  return {
    isAuthenticated: selectUserIsLoggedIn(state),
    isLoading: selectUserIsLoading(state),
    ...ownProps
  };
};

const AuthRequired = ({ isAuthenticated, isLoading, children }) => {
  if (isLoading || !isAuthenticated) {
    return null;
  }

  return children;
};

export default connect(mapStateToProps)(AuthRequired);
